import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { ChangePasswordRequest, ChangePasswordResult, SharedPasswordRepository } from "../../repositories/shared-password-repository";
import { LoadingComponent } from "../loading/loading.component";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ToastService } from "../../services/toast.service";

@Component({
	selector: "jhm-change-password",
	templateUrl: "./change-password.html",
	styleUrls: ["./change-password.scss"],
	imports: [MatFormFieldModule, MatInputModule, FormsModule, LoadingComponent]
})
export class ChangePasswordComponent
{
	private toastService = inject(ToastService);
	private sharedPasswordRepository: SharedPasswordRepository;

	@Output()
	public closeModal: EventEmitter<void> = new EventEmitter<void>();

	@Output()
	public valid: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Input() set username(value: string)
	{
		this._username = value;
	}
	public currentPassword: string;
	public newPassword: string;
	public verifiedPassword: string;
	public _username: string;
	public loading: boolean;

	public constructor(sharedPasswordRepository: SharedPasswordRepository)
	{
		this.sharedPasswordRepository = sharedPasswordRepository;
		this.valid.emit(false);
	}

	public changePassword(): void
	{
		this.loading = true;
		const changePasswordRequestDto: ChangePasswordRequest = new ChangePasswordRequest(this._username, this.currentPassword, this.newPassword);
		this.sharedPasswordRepository.changePassword(changePasswordRequestDto).subscribe((changePassword: ChangePasswordResult) =>
		{
			this.toastService.show(changePassword.message, changePassword.successful ? "success" : "error");
			this.loading = false;
			this.closeModal.emit();
		});
	}

	public checkValid(): void {
		if (this.newPassword && this.verifiedPassword && this.currentPassword) {
			this.valid.emit(this.newPassword === this.verifiedPassword);
		}
		else {
			this.valid.emit(false);
		}
	}
}
